export const styles = theme => ({
    space: {
        padding: '15px',
        [theme.breakpoints.up('sm')]: {
            padding: '30px',
        },
    },
    otherSpace: {
        display: 'flex',
        marginTop: '50px',
        [theme.breakpoints.up('sm')]: {
            marginTop: '25px',
        },
    },
    avatar: {
        width: '50px',
        height: '50px',
        background: 'white',
    },
    headerDiv: {
        display: 'flex',
        alignItems: 'center',
        marginLeft: 'auto',
        marginRight: 'auto',
        width: 'fit-content',
        [theme.breakpoints.up('sm')]: {
            alignItems: 'initial',
            width: 'initial',
            marginRight: 'initial',
            marginLeft: 'initial',
        }
    },
    headerTypography: {
        color: 'white',
        fontWeight: 'bold',
        marginLeft: '30px'
    },
    paragraph: {
        color: 'white',
        textAlign: 'center',
        marginRight: 'auto',
        marginLeft: 'auto',
        [theme.breakpoints.up('sm')]: {
            marginLeft: '80px',
            marginTop: '-10px',
            textAlign: 'initial',
        }
    },
    newAppointmentLink: {
        display: 'inline-block',
        marginLeft: 'auto',
        marginRight: 'auto',
        [theme.breakpoints.up('sm')]: {
            marginRight: 'initial'
        }
    }
});
